var map = {
	"./Loading-Icon.gif": 1205,
	"./app-awareness-phone.png": 404,
	"./app-modal-android@2x.png": 690,
	"./app-modal-iphone@2x.png": 691,
	"./app-promo-banner-background.png": 1206,
	"./box-prices/best-value.png": 692,
	"./box-prices/box-prices-hero.jpg": 783,
	"./box-prices/couples-box.jpg": 1207,
	"./box-prices/family-box.jpg": 1208,
	"./box-prices/four-person-box.jpg": 523,
	"./box-prices/most-popular.png": 693,
	"./box-prices/two-person-box.jpg": 522,
	"./discount-modal-header.jpg": 525,
	"./earn-reward-background.jpg": 1209,
	"./five-recipes/five-recipes.png": 694,
	"./gousto-boxes.jpg": 695,
	"./gousto-welcome-journey-rollover.jpg": 1210,
	"./hungry-for-savings.png": 1211,
	"./menu/FebYouary_desktop.jpg": 1212,
	"./menu/FebYouary_mobile.jpg": 1213,
	"./menu/FebYouary_tablet.jpg": 1214,
	"./menu/default_desktop_no_click.png": 1215,
	"./menu/default_mobile_no_click.png": 1216,
	"./menu/default_tablet_no_click.png": 1217,
	"./menu/spottyTileBorder.png": 696,
	"./my-gousto-pricing-modal.svg": 1218,
	"./pause-osr-modal-bg.jpg": 1219,
	"./product-placeholder.png": 526,
	"./recipe-placeholder.png": 338,
	"./red-rice-pattern.png": 527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 674;